import Skeleton from "../../../components/Skeleton/Skeleton";
import useScreenSize from "../../../hooks/useScreenSize";

const PageSkeleton = () => {
  const { isMobile } = useScreenSize();

  if (isMobile) {
    return (
      <div className="flex flex-col gap-4">
        {/* Currency tabs + download button */}
        <div className="flex items-center justify-between">
          <div className="flex gap-3">
            <Skeleton width="64px" height="32px" borderRadius="0.5rem" />
            <Skeleton width="64px" height="32px" borderRadius="0.5rem" />
            <Skeleton width="64px" height="32px" borderRadius="0.5rem" />
          </div>
          <Skeleton width="32px" height="32px" borderRadius="0.5rem" />
        </div>

        {/* Criterio + Fecha inputs */}
        <div className="flex gap-3">
          <Skeleton width="50%" height="48px" borderRadius="0.5rem" />
          <Skeleton width="50%" height="48px" borderRadius="0.5rem" />
        </div>

        {/* Portfolio chart */}
        <Skeleton width="100%" height="180px" borderRadius="0.75rem" />

        {/* Category tabs */}
        <div className="flex gap-4 overflow-hidden">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} width="72px" height="28px" borderRadius="0.5rem" />
          ))}
        </div>

        {/* Instrument card rows */}
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex flex-col gap-2 py-3 border-b border-[#EBEBEB]">
            <div className="flex items-center justify-between">
              <Skeleton width="80px" height="16px" />
              <Skeleton width="100px" height="32px" borderRadius="0.5rem" />
            </div>
            <div className="flex justify-between">
              <Skeleton width="100px" height="14px" />
              <Skeleton width="80px" height="14px" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 h-full min-h-[100vh]">
      <div className="flex items-center justify-between">
        <Skeleton width="297.6px" height="32px" />
        <Skeleton width="528px" height="43px" />
      </div>

      <Skeleton width="100%" height="332px" />
    </div>
  );
};

export default PageSkeleton;
